import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import styles from "./LanguageSelector.module.scss";
import classNames from "classnames/bind";
import { useLanguageStore } from "../../stores/Language/useLanguageStore";

const cx = classNames.bind(styles);

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Sử dụng Zustand store
  const {
    currentLanguage,
    setLanguage,
    setCurrency,
    initializeTranslations,
    loading,
  } = useLanguageStore();

  const dropdownRef = useRef(null);

  const languages = [
    {
      code: "en",
      name: "ENGLISH",
      currency: { code: "USD", symbol: "$", rate: 20000, default_currency: "USD" }
    },
    {
      code: "vi",
      name: "VIETNAM",
      currency: { code: "VND", symbol: "₫", rate: 20000, default_currency: "USD" }
    },
  ];

  // Tìm thông tin ngôn ngữ hiện tại - mặc định là tiếng Việt
  const currentLanguageInfo = languages.find(lang => lang.code === currentLanguage) || languages.find(lang => lang.code === 'vi');

  useEffect(() => {
    // Khởi tạo translations ngay khi component mount
    initializeTranslations();
  }, [initializeTranslations]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferred-language');
    const savedCurrency = localStorage.getItem('preferred-currency');

    if (savedLanguage && savedLanguage !== currentLanguage) {
      setLanguage(savedLanguage);
    }

    if (savedCurrency) {
      try {
        const currencyData = JSON.parse(savedCurrency);
        setCurrency(currencyData);
      } catch (error) {
        console.error('Error parsing saved currency:', error);
      }
    }
  }, [currentLanguage, setLanguage, setCurrency]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLanguageSelect = (language) => {
    setLanguage(language.code);
    setCurrency(language.currency);
    setIsOpen(false);
  };

  return (
    <div className={cx("language-selector")} ref={dropdownRef}>
      <button
        className={cx("selector-button", { loading })}
        onClick={() => setIsOpen(!isOpen)}
      >
        {currentLanguageInfo.code.toUpperCase()}
        {loading ? (
          <div className={cx("loading-spinner")} />
        ) : isOpen ? (
          <ChevronUp className={cx("icon")} />
        ) : (
          <ChevronDown className={cx("icon")} />
        )}
      </button>


      {isOpen && (
        <ul className={cx("dropdown")}>
          {languages.map((language) => (
            <li
              key={language.code}
              className={cx("dropdown-item", {
                active: language.code === currentLanguage
              })}
              onClick={() => handleLanguageSelect(language)}
            >
              <span className={cx("language-name")}>{language.name}</span>
              <span className={cx("currency")}>{language.currency.code}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
